import React, {Component} from 'react';

import Calculator from "../Calculator"

class App extends Component {
    render() {
        return (
            <div>
                <div>Welcome</div>
                {/*<Calculator></Calculator>*/}
            </div>

        )
    }
}

export default App
